import { Injectable } from '@angular/core';
import { GatewayAPIService } from '../../core/gateway-api.service';
import {
  Message,
  Conversation,
  getMessagesResponse,
  getQueueResponse,
  pingChatResponse,
} from './chatModel';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  options = { authenticate: true, setRoot: true };

  constructor(private api: GatewayAPIService) {}

  start(name: string, email: string): Promise<Conversation> {
    return this.api
      .apiCallSane(
        '/chat/start',
        'POST',
        this.api.getDefaultHeaders(),
        null,
        { name, email },
        this.options,
      )
      .then((response: Partial<Conversation>) => new Conversation(response));
  }

  join(supportName: string, conversationId: string): Promise<Conversation> {
    return this.api
      .apiCallSane(
        '/chat/join',
        'POST',
        this.api.getDefaultHeaders(),
        null,
        { supportName, conversationId },
        this.options,
      )
      .then((response: Partial<Conversation>) => new Conversation(response));
  }

  unjoin(conversationId: string, supportName: string): Promise<Conversation> {
    return this.api
      .apiCallSane(
        '/chat/unjoin',
        'POST',
        this.api.getDefaultHeaders(),
        null,
        { supportName, conversationId },
        this.options,
      )
      .then((response: Partial<Conversation>) => new Conversation(response));
  }

  end(conversationId: string, role: string, reason: string): Promise<null> {
    return this.api
      .apiCallSane(
        '/chat/end',
        'POST',
        this.api.getDefaultHeaders(),
        null,
        { conversationId, role, reason },
        this.options,
      )
      .then((response: Partial<any>) => null);
  }

  ping(conversationId: string, role: string): Promise<pingChatResponse> {
    return this.api
      .apiCallSane(
        '/chat/ping',
        'POST',
        this.api.getDefaultHeaders(),
        null,
        { conversationId, role },
        this.options,
      )
      .then(
        (response: Partial<pingChatResponse>) => new pingChatResponse(response),
      );
  }

  getMessages(
    conversationId: string,
    lastMessageId: number,
  ): Promise<getMessagesResponse> {
    return this.api
      .apiCallSane(
        '/chat/messages',
        'GET',
        this.api.getDefaultHeaders(),
        { conversationId, lastMessageId },
        null,
        this.options,
      )
      .then(
        (response: Partial<getMessagesResponse>) =>
          new getMessagesResponse(response),
      );
  }

  postMessage(
    conversationId: string,
    role: string,
    message: string,
  ): Promise<Message> {
    return this.api
      .apiCallSane(
        '/chat/message',
        'POST',
        this.api.getDefaultHeaders(),
        null,
        { conversationId, role, message },
        this.options,
      )
      .then((response: Partial<Message>) => new Message(response));
  }

  getQueue(
    pageNum: number = 0,
    pageSize: number = 10,
  ): Promise<getQueueResponse> {
    return this.api
      .apiCallSane(
        '/chat/queue',
        'GET',
        this.api.getDefaultHeaders(),
        { paginated: true, pageNum, pageSize },
        null,
        this.options,
      )
      .then(
        (response: Partial<getQueueResponse>) => new getQueueResponse(response),
      );
  }
}
